import React from 'react';

import { elPubTypes } from './actions'


const initialState = {
    isFetching: false,
}


export function electronicPublication(state = initialState, action) {

    switch(action.type) {

        case elPubTypes.REQUEST:
            state = {...state}
            state.isFetching = true
            return state

        case elPubTypes.RECEIVE:
            state = {...state, isFetching: false}
            state.data = action.data

            return state


        default:
            return state
    }
}